import React, { useContext, useEffect, useState } from 'react';
import axios from 'axios';
import parseMax from 'libphonenumber-js/max';
// import { useChatContext } from 'stream-chat-react';
import { GlobalContext } from '../../GlobalState';
//
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import Grid from '@mui/material/Grid';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import AddChannelIcon from '@mui/icons-material/AddCircleOutline';

const tpl_defaultFormData = {
  phoneNumber: '',
  firstName: '',
  lastName: '',
  recordType: '',
  companyName: '',
  unitCode: '',
  response: '',
};
const defaultErrorData = {
  phoneNumber: '',
  firstName: '',
  lastName: '',
  recordType: '',
  companyName: '',
  unitCode: '',
  response: ''
};
const errorMsgTypes = {
  required: 'Required value',
  invalid: 'Invalid value',
  invalid_phoneNumber_syntax: 'Not an international number',
  invalid_phoneNumber_int: 'Invalid international number',
  submit: 'Oops! Form couldn\'t be submitted',
  submit_phoneNumber: 'Phone number is being used'
};

export const PrimeAddModal = () => {
  const { globalState } = useContext(GlobalContext);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [defaultFormData, setDefaultFormData] = useState(tpl_defaultFormData);
  const [formData, setFormData] = useState(tpl_defaultFormData);
  const [errorData, setErrorData] = useState(defaultErrorData);
  const [doubleConfirmation, setDoubleConfirmation] = useState(false);
  useEffect(() => {
    const loadFormRecordTypes = async () => {
      try {
        if (typeof globalState.app_config.authToken !== 'string' || globalState.app_config.authToken === null || globalState.app_config.authToken === 'none') return setDefaultFormData(prev => ({...prev, recordType: {none: 0}}));
        const axiosReq = { 'token': globalState.app_config.authToken };
        const axiosRes = await axios.post(globalState.app_config.authEnv+'/address_book/categories', axiosReq);
        if (axiosRes.status === 200 && axiosRes.data && axiosRes.data.result === true) {
          const categoriesArray = axiosRes.data.categories;
          if (typeof categoriesArray === 'object' && Array.isArray(categoriesArray) === true && categoriesArray !== null) {
            let categoriesMap = {};
            categoriesArray.map(category => categoriesMap[category.title] = category.id)
            setDefaultFormData(prev => ({...prev, recordType: categoriesMap}));
          }
          else setDefaultFormData(prev => ({...prev, recordType: {none: 0}}))
        }
        else setDefaultFormData(prev => ({...prev, recordType: {none: 0}}))
      }
      catch (err) {
        console.log('Error', err);
      }
    };
    if (isModalOpen === true && defaultFormData.recordType === '') loadFormRecordTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isModalOpen, defaultFormData.recordType])
  const clickOpenModal = () => setIsModalOpen(true);
  const clickCloseModal = () => {
    setIsModalOpen(false);
    setDoubleConfirmation(false);
    setDefaultFormData(tpl_defaultFormData);
    setFormData(tpl_defaultFormData);
    setErrorData(defaultErrorData);
  }
  const inputChange = (e) => {
    if (e.target.name === 'phoneNumber') e.target.value = e.target.value.length > 0 ? e.target.value.match(/[0-9]|\+|-|\(|\)/g, '').join('') : '';
    setFormData(prev => ({...prev, [e.target.name]: e.target.value}));
  }
  const formValidation = () => {
    let isValidForm = true;
    let errorDataTmp = {...defaultErrorData};
    // phoneNumber
    if (!formData.phoneNumber) {
      errorDataTmp.phoneNumber = 'required';
      isValidForm = false;
    }
    else if (formData.phoneNumber.startsWith('+') === false) {
      errorDataTmp.phoneNumber = 'invalid_phoneNumber_syntax';
      isValidForm = false;
    }
    else {
      const parsedPhoneNumber = parseMax(formData.phoneNumber, { defaultCountry: '', extract: false });
      if (parsedPhoneNumber === undefined) {
        errorDataTmp.phoneNumber = 'invalid_phoneNumber_int';
        isValidForm = false;
      }
      else {
        if (parsedPhoneNumber.isValid() === false) {
          errorDataTmp.phoneNumber = 'invalid_phoneNumber_int';
          isValidForm = false;
        }
      }
    }
    // recordType
    if (formData.recordType === '') {
      errorDataTmp.recordType = 'required';
      isValidForm = false;
    }
    else if (Object.keys(defaultFormData.recordType).includes(formData.recordType) === false || Object.keys(defaultFormData.recordType).includes('none') === true) {
      errorDataTmp.recordType = 'invalid';
      isValidForm = false;
    }
    setErrorData(errorDataTmp);
    return isValidForm;
  }
  const createPrime = async (e) => {
    try {
      let isValidForm = formValidation();
      if (isValidForm === false) return setDoubleConfirmation(false);
      if (doubleConfirmation === false) return setDoubleConfirmation(true);
      const parsedPhoneNumber = parseMax(formData.phoneNumber, { defaultCountry: '', extract: false });
      if (parsedPhoneNumber === undefined || parsedPhoneNumber.isValid() === false) return setDoubleConfirmation(false);
      let axiosReq = {
        token: globalState.app_config.authToken,
        data: {
          id: null,
          phone_number: parsedPhoneNumber.number,
          first_name: formData.firstName,
          last_name: formData.lastName,
          company_name: formData.companyName,
          unit_number: formData.unitCode,
          category_id: defaultFormData.recordType[formData.recordType]
        }
      };
      const axiosRes = await axios.put(globalState.app_config.authEnv+'/address_book', axiosReq);
      if (axiosRes.status === 200 && axiosRes.data && axiosRes.data.result === true) clickCloseModal();
      else if (axiosRes.status === 200 && axiosRes.data && axiosRes.data.result === false && axiosRes.data.code === 'CODE_USED') {
        setDoubleConfirmation(false);
        setErrorData({...errorData, phoneNumber: 'submit_phoneNumber'});
      }
      else throw Error('phonebook-not-created');
    } catch (err) {
      console.log('Error', err);
      setErrorData({...errorData, response: 'submit'})
    }
  };
  return (
    <>
    <IconButton color='primary' sx={{ p: '10px', mr: 0.5 }} aria-label='new channel' onClick={clickOpenModal}>
      <Tooltip title='New Channel' placement='bottom'><AddChannelIcon /></Tooltip>
    </IconButton>
    <Dialog fullScreen={false} scroll={'paper'} fullWidth={true} maxWidth={'sm'} open={isModalOpen} onClose={clickCloseModal}>
      <DialogTitle>
        <Grid container direction='row' justifyContent='flex-start' alignItems='center' spacing={0}>
          <AddChannelIcon color='primary' sx={{mr: 2}} /><Typography component='div' variant='h6' textAlign='left' color='primary'>{'Phonebook contact'}</Typography>
        </Grid>
      </DialogTitle>
      <DialogContent sx={{p: 0, pl: 1, pr: 1}}>
        <Grid container direction='row' justifyContent='center' alignItems='center' spacing={0} sx={{width: '100%', '& .MuiTextField-root': { m: 1, width: '25ch' },}}>
          <Grid container item direction='column' justifyContent='center' alignItems='center' spacing={0} sm={6}>
            <Grid item xs={12}>
              <TextField required={true} name='phoneNumber' label='Phone Number' variant='outlined' onChange={inputChange} value={formData.phoneNumber} helperText={errorMsgTypes[errorData.phoneNumber] || ' '} error={errorData.phoneNumber !== ''} />
            </Grid>
            <Grid item xs={12}>
              <TextField required={false} name='firstName' label='First Name' variant='outlined' onChange={inputChange} value={formData.firstName} helperText={errorMsgTypes[errorData.firstName] || ' '} error={errorData.firstName !== ''}/>
            </Grid>
            <Grid item xs={12}>
              <TextField required={false} name='lastName' label='Last Name' variant='outlined' onChange={inputChange} value={formData.lastName} helperText={errorMsgTypes[errorData.lastName] || ' '} error={errorData.lastName !== ''}/>
            </Grid>
          </Grid>
          <Grid container item direction='column' justifyContent='center' alignItems='center' spacing={0} sm={6}>
            <Grid item xs={12}>
              <TextField required={false} name='companyName' label='Company Name' variant='outlined' onChange={inputChange} value={formData.companyName} helperText={errorMsgTypes[errorData.companyName] || ' '} error={errorData.companyName !== ''} />
            </Grid>
            <Grid item xs={12}>
              <TextField required={false} name='unitCode' label='Unit Number' variant='outlined' onChange={inputChange} value={formData.unitCode} helperText={errorMsgTypes[errorData.unitCode] || ' '} error={errorData.unitCode !== ''} />
            </Grid>
            <Grid item xs={12}>
              <TextField select required={true} name='recordType' label='Record Type' onChange={inputChange} value={formData.recordType} helperText={errorMsgTypes[errorData.recordType] || ' '} error={errorData.recordType !== ''}>
                {Object.keys(defaultFormData.recordType).map(item => <MenuItem key={item} value={item}>{item}</MenuItem>)}
              </TextField>
            </Grid>
          </Grid>
          {errorMsgTypes[errorData.response] && <Typography ml='auto' mr='auto' color='error.main' component='div' variant='body2'>{errorMsgTypes[errorData.response]}</Typography>}
        </Grid>
      </DialogContent>
      <DialogActions sx={{mb: 2, mr: 2}}>
        <Button color={doubleConfirmation === true ? 'warning' : 'primary'} variant='outlined' onClick={createPrime}>{doubleConfirmation === true ? 'Are you sure?' : 'Create'}</Button>
        <Button variant='text' onClick={clickCloseModal}>{'Cancel'}</Button>
      </DialogActions>
    </Dialog>
    </>
  );
};